import React, { useEffect, useState } from 'react';

// WEB DEMO ONLY: sits in the sidebar in place of Sign Out - what this is, how many tests the
// visitor has recorded, and the ways out.
function DemoControls() {
  const [engine, setEngine] = useState(null);
  const [, setTick] = useState(0);
  useEffect(() => {
    let off = () => {};
    import('./demoEngine').then(m => { setEngine(m); off = m.onDemoChange(() => setTick(t => t + 1)); });
    return () => off();
  }, []);
  if (!engine) return null;
  const mine = engine.visitorTestCount();
  const btn = { display: 'block', width: '100%', boxSizing: 'border-box', padding: '8px 10px', marginTop: '6px', backgroundColor: '#1a1a2e', border: '1px solid #3a3a5a', borderRadius: '6px', color: '#ffffff', fontSize: '12px', cursor: 'pointer', textAlign: 'left', textDecoration: 'none' };
  return (
    <div style={{ margin: '32px 16px 0', padding: '12px', borderRadius: '8px', backgroundColor: '#3a3010', border: '1px solid #ffcc00' }}>
      <div style={{ color: '#ffcc00', fontSize: '12px', fontWeight: 'bold', marginBottom: '4px' }}>DEMO - sample data</div>
      <div style={{ color: '#d0d0e0', fontSize: '12px', lineHeight: 1.45, marginBottom: '4px' }}>
        {mine ? `Your tests from the floor app: ${mine}. Find them under Reports.` : 'Record a test on the floor app and it shows up here under Reports.'}
      </div>
      <a style={btn} href="/floor/" target="_blank" rel="noreferrer">Open the floor app ↗</a>
      <button style={btn} onClick={() => { if (window.confirm('Start over? Tests you recorded are removed.')) { engine.resetDemo(); window.location.reload(); } }}>Start over</button>
      <a style={btn} href="/">Demo home</a>
    </div>
  );
}

export default DemoControls;
